//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _findLast from 'lodash/findLast'
import Fields from './fields'
import SwoopForm from '@/components/SwoopForm'
import ActionButtons from '@/components/ActionButtons'
import Heading from '@/components/Heading'
import googlePlaces from '@/utils/googlePlaces'

const GROUP = process.env.VUE_APP_MODE
let google, geocoder, map, marker, autocomplete

export default {
  name: 'Location',

  components: {
    SwoopForm,
    Heading,
    ActionButtons
  },

  props: {
    quote: Object
  },

  data() {
    return {
      form: null,
      product: {
        use: process.env.VUE_APP_FIXED_WIRELESS_ID,
        group: GROUP,
        lookupGroup: GROUP,
        input: {
          address: '',
          height: ''
        }
      }
    }
  },

  async created() {
    // Default to last product address & height available
    let lastProductWithAnAddress = _findLast(
      this.quote.products,
      p => p.fields.address
    )
    if (lastProductWithAnAddress) {
      this.product.input.address = lastProductWithAnAddress.fields.address.value
      this.product.input.height = lastProductWithAnAddress.fields.height.value
    }

    try {
      google = await googlePlaces()
      geocoder = new google.maps.Geocoder()
      autocomplete = new google.maps.places.AutocompleteService()
      map = new google.maps.Map(this.$refs.map, {
        gestureHandling: 'cooperative', // Ensures map does not prevent page scrolling
        zoom: 18,
        minZoom: 10,
        streetViewControl: false,
        controlSize: 25,
        backgroundColor: 'none',
        mapTypeId: google.maps.MapTypeId.HYBRID
      })
      marker = null
      if (this.product.input.address) {
        this.updateMap()
      }
    } catch (error) {
      console.log(error) // eslint-disable-line no-console
    }
  },

  computed: {
    fields() {
      return Fields.location(this.getAddresses)
    }
  },

  methods: {
    getAddresses(value, done) {
      if (value.length > 6) {
        autocomplete.getPlacePredictions(
          { input: value, componentRestrictions: { country: ['au'] } },
          results => {
            done(results ? results.map(address => address.description) : [])
          }
        )
      } else {
        done([])
      }
    },

    formInput(data, field) {
      if (field.id === 'input.address') {
        this.selectAddress(field.value)
      }
    },

    selectAddress(address) {
      this.product.input.address = address
      this.form.refresh()
      this.updateMap()
    },

    updateMap() {
      this.$nextTick(() => {
        try {
          geocoder.geocode(
            { address: this.product.input.address },
            (results, status) => {
              if (status === 'OK' && results.length) {
                map.setCenter(results[0].geometry.location)
                this.setMarker(results[0])
              }
            }
          )
        } catch (error) {
          console.log(error) // eslint-disable-line no-console
        }
      })
    },

    setMarker(addressResult) {
      let selectAddress = this.selectAddress
      if (!marker) {
        marker = new google.maps.Marker({
          draggable: true,
          position: addressResult.geometry.location,
          map,
          title: addressResult.formatted_address
        })

        google.maps.event.addListener(marker, 'dragend', function() {
          geocoder.geocode(
            {
              latLng: marker.getPosition()
            },
            responses => {
              if (responses && responses.length > 0) {
                selectAddress(responses[0].formatted_address)
              }
            }
          )
        })
      } else {
        marker.setPosition(addressResult.geometry.location)
        marker.setTitle(addressResult.formatted_address)
      }
    },

    cancel() {
      this.$emit('cancel')
    },

    save() {
      if (this.form.focusError()) {
        return
      } else {
        this.$emit('save', this.product)
      }
    }
  }
}
